// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__303ek","header":"MessagesList_header__2r0U_","chat":"MessagesList_chat__3CoR6"};